import React, { useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Input } from '../components/ui/Input';
import { Search, Filter, ShoppingBag, Bed, UtensilsCrossed, Armchair, Laptop, Sparkles, MessageCircle, MapPin, Clock, X, Phone, Mail, Heart, TrendingUp, Grid3x3, List } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const categories = [{
  id: 'all',
  label: 'All Items',
  icon: ShoppingBag
}, {
  id: 'beds',
  label: 'Beds & Mattresses',
  icon: Bed
}, {
  id: 'kitchen',
  label: 'Kitchen',
  icon: UtensilsCrossed
}, {
  id: 'furniture',
  label: 'Furniture',
  icon: Armchair
}, {
  id: 'electronics',
  label: 'Electronics',
  icon: Laptop
}, {
  id: 'decor',
  label: 'Decor & Others',
  icon: Sparkles
}];
const products = [{
  id: 1,
  name: 'Single Bed Frame + Foam Mattress',
  price: '₦25,000',
  category: 'beds',
  condition: 'Good',
  location: 'Unilag, Moremi Hall',
  seller: 'Chioma A.',
  phone: '+234 803 456 7890',
  email: 'chioma@student.edu.ng',
  posted: '2 hrs ago',
  description: 'Sturdy metal bed frame with foam mattress. Used for 1 year, well maintained. Perfect for student accommodation.',
  image: 'https://images.unsplash.com/photo-1505693416388-b0346efee539?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: true
}, {
  id: 2,
  name: 'Mini Fridge (Table Top)',
  price: '₦35,000',
  category: 'kitchen',
  condition: 'Like New',
  location: 'Yaba Tech',
  seller: 'David O.',
  phone: '+234 805 123 4567',
  email: 'david@student.edu.ng',
  posted: '5 hrs ago',
  description: 'Compact mini fridge, barely used. Energy efficient, perfect for keeping drinks and snacks cold.',
  image: 'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: true
}, {
  id: 3,
  name: 'Study Desk & Chair Set',
  price: '₦15,000',
  category: 'furniture',
  condition: 'Fair',
  location: 'Unilag, Jaja',
  seller: 'Emmanuel J.',
  phone: '+234 807 890 1234',
  email: 'emmanuel@student.edu.ng',
  posted: '1 day ago',
  description: 'Wooden desk with matching chair. Shows some wear but still functional. Great for studying.',
  image: 'https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 4,
  name: 'Electric Rice Cooker (3L)',
  price: '₦8,000',
  category: 'kitchen',
  condition: 'New',
  location: 'LUTH',
  seller: 'Sarah K.',
  phone: '+234 809 234 5678',
  email: 'sarah@student.edu.ng',
  posted: '3 hrs ago',
  description: 'Brand new rice cooker, never used. Received as gift but already have one. Original packaging included.',
  image: 'https://images.unsplash.com/photo-1544233726-9f1d2b27be8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 5,
  name: 'Standing Fan (Ox Brand)',
  price: '₦12,000',
  category: 'electronics',
  condition: 'Good',
  location: 'Unilag, Mariere',
  seller: 'Tobi A.',
  phone: '+234 806 345 6789',
  email: 'tobi@student.edu.ng',
  posted: '4 hrs ago',
  description: 'Powerful standing fan, works perfectly. Moving out of hostel, need to sell quickly.',
  image: 'https://images.unsplash.com/photo-1618941716939-553df0c69278?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 6,
  name: 'Gas Cylinder (3kg) + Burner',
  price: '₦9,500',
  category: 'kitchen',
  condition: 'Good',
  location: 'Unilag, Kofo',
  seller: 'Blessing M.',
  phone: '+234 808 567 8901',
  email: 'blessing@student.edu.ng',
  posted: '6 hrs ago',
  description: 'Small gas cylinder with single burner. Perfect for cooking in hostel. Includes gas regulator.',
  image: 'https://images.unsplash.com/photo-1585237672814-8f85a8118bf6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 7,
  name: 'Double Bed with Spring Mattress',
  price: '₦45,000',
  category: 'beds',
  condition: 'Like New',
  location: 'Covenant University',
  seller: 'Michael O.',
  phone: '+234 803 111 2222',
  email: 'michael@student.edu.ng',
  posted: '8 hrs ago',
  description: 'Queen size bed with high-quality spring mattress. Barely used for 6 months. Excellent condition.',
  image: 'https://images.unsplash.com/photo-1540574163026-643ea20ade25?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: true
}, {
  id: 8,
  name: 'Microwave Oven (Sharp)',
  price: '₦22,000',
  category: 'kitchen',
  condition: 'Good',
  location: 'Babcock University',
  seller: 'Grace A.',
  phone: '+234 805 333 4444',
  email: 'grace@student.edu.ng',
  posted: '10 hrs ago',
  description: 'Sharp microwave in working condition. Great for quick meals and reheating.',
  image: 'https://images.unsplash.com/photo-1585659722983-3a675dabf23d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 9,
  name: 'Bookshelf (5-Tier)',
  price: '₦18,000',
  category: 'furniture',
  condition: 'Good',
  location: 'UI, Ibadan',
  seller: 'Tunde B.',
  phone: '+234 807 555 6666',
  email: 'tunde@student.edu.ng',
  posted: '12 hrs ago',
  description: 'Wooden bookshelf with 5 tiers. Perfect for organizing textbooks and supplies.',
  image: 'https://images.unsplash.com/photo-1594620302200-9a762244a156?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 10,
  name: 'Laptop Stand + Cooling Pad',
  price: '₦6,500',
  category: 'electronics',
  condition: 'Like New',
  location: 'Unilag, Akoka',
  seller: 'Kemi L.',
  phone: '+234 809 777 8888',
  email: 'kemi@student.edu.ng',
  posted: '14 hrs ago',
  description: 'Adjustable laptop stand with built-in cooling fan. Improves posture and keeps laptop cool.',
  image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 11,
  name: 'Wall Clock & Decorative Mirror',
  price: '₦4,500',
  category: 'decor',
  condition: 'New',
  location: 'LASU',
  seller: 'Ayo D.',
  phone: '+234 806 999 0000',
  email: 'ayo@student.edu.ng',
  posted: '16 hrs ago',
  description: 'Modern wall clock and decorative mirror set. Brand new, never mounted.',
  image: 'https://images.unsplash.com/photo-1563861826100-9cb868fdbe1c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 12,
  name: 'Electric Kettle (1.7L)',
  price: '₦5,000',
  category: 'kitchen',
  condition: 'Good',
  location: 'Yaba Tech',
  seller: 'Funmi S.',
  phone: '+234 803 222 3333',
  email: 'funmi@student.edu.ng',
  posted: '18 hrs ago',
  description: 'Fast boiling electric kettle. Perfect for tea, coffee, and instant noodles.',
  image: 'https://images.unsplash.com/photo-1563299796-17596ed6b017?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 13,
  name: 'Wardrobe (Portable)',
  price: '₦20,000',
  category: 'furniture',
  condition: 'Like New',
  location: 'FUTA, Akure',
  seller: 'Seun M.',
  phone: '+234 805 444 5555',
  email: 'seun@student.edu.ng',
  posted: '1 day ago',
  description: 'Portable fabric wardrobe with metal frame. Easy to assemble, spacious storage.',
  image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 14,
  name: 'LED Desk Lamp',
  price: '₦3,500',
  category: 'electronics',
  condition: 'New',
  location: 'Covenant University',
  seller: 'Joy O.',
  phone: '+234 807 666 7777',
  email: 'joy@student.edu.ng',
  posted: '1 day ago',
  description: 'Adjustable LED desk lamp with USB charging port. Perfect for late-night studying.',
  image: 'https://images.unsplash.com/photo-1507473885765-e6ed057f782c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}, {
  id: 15,
  name: 'Blender (Binatone)',
  price: '₦11,000',
  category: 'kitchen',
  condition: 'Good',
  location: 'Unilag, Moremi',
  seller: 'Ada N.',
  phone: '+234 809 888 9999',
  email: 'ada@student.edu.ng',
  posted: '2 days ago',
  description: 'Powerful blender for smoothies and food prep. Works perfectly, minor scratches on base.',
  image: 'https://images.unsplash.com/photo-1585515320310-259814833e62?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  featured: false
}];
export function MarketplacePage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedProduct, setSelectedProduct] = useState<(typeof products)[0] | null>(null);
  const [savedItems, setSavedItems] = useState<number[]>([]);
  const [priceRange, setPriceRange] = useState({
    min: '',
    max: ''
  });
  const [selectedConditions, setSelectedConditions] = useState<string[]>([]);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [sortBy, setSortBy] = useState('recent');
  const toggleSave = (productId: number) => {
    setSavedItems(prev => prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]);
  };
  const toggleCondition = (condition: string) => {
    setSelectedConditions(prev => prev.includes(condition) ? prev.filter(c => c !== condition) : [...prev, condition]);
  };
  let filteredProducts = products.filter(product => {
    const matchesCategory = activeCategory === 'all' || product.category === activeCategory;
    const matchesSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) || product.description.toLowerCase().includes(searchQuery.toLowerCase());
    const price = parseInt(product.price.replace(/[₦,]/g, ''));
    const minPrice = priceRange.min ? parseInt(priceRange.min) : 0;
    const maxPrice = priceRange.max ? parseInt(priceRange.max) : Infinity;
    const matchesPrice = price >= minPrice && price <= maxPrice;
    const matchesCondition = selectedConditions.length === 0 || selectedConditions.includes(product.condition);
    return matchesCategory && matchesSearch && matchesPrice && matchesCondition;
  });
  // Sort products
  if (sortBy === 'price-low') {
    filteredProducts = [...filteredProducts].sort((a, b) => parseInt(a.price.replace(/[₦,]/g, '')) - parseInt(b.price.replace(/[₦,]/g, '')));
  } else if (sortBy === 'price-high') {
    filteredProducts = [...filteredProducts].sort((a, b) => parseInt(b.price.replace(/[₦,]/g, '')) - parseInt(a.price.replace(/[₦,]/g, '')));
  }
  // Separate featured products
  const featuredProducts = filteredProducts.filter(p => p.featured);
  const regularProducts = filteredProducts.filter(p => !p.featured);
  const getConditionColor = (condition: string) => {
    switch (condition) {
      case 'New':
        return 'bg-emerald-100 text-emerald-800';
      case 'Like New':
        return 'bg-green-100 text-green-800';
      case 'Good':
        return 'bg-yellow-100 text-yellow-800';
      case 'Fair':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-slate-100 text-slate-800';
    }
  };
  return <div className="min-h-screen bg-slate-50 pt-20" data-id="element-794">
      <Navigation data-id="element-795" />

      {/* Product Detail Modal */}
      <AnimatePresence data-id="element-796">
        {selectedProduct && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={() => setSelectedProduct(null)} data-id="element-797">
            <motion.div initial={{
          scale: 0.9,
          y: 20
        }} animate={{
          scale: 1,
          y: 0
        }} exit={{
          scale: 0.9,
          y: 20
        }} className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-798">
              <div className="sticky top-0 bg-white border-b border-slate-200 p-4 flex justify-between items-center z-10" data-id="element-799">
                <h2 className="text-xl font-bold text-brand-dark" data-id="element-800">
                  Product Details
                </h2>
                <button onClick={() => setSelectedProduct(null)} className="p-2 hover:bg-slate-100 rounded-full transition-colors" data-id="element-801">
                  <X className="w-5 h-5" data-id="element-802" />
                </button>
              </div>

              <div className="p-6" data-id="element-803">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-804">
                  <div className="relative" data-id="element-805">
                    <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-96 object-cover rounded-xl" data-id="element-806" />
                    <span className={`absolute top-4 right-4 px-3 py-1 rounded-full text-xs font-bold shadow-sm ${getConditionColor(selectedProduct.condition)}`} data-id="element-807">
                      {selectedProduct.condition}
                    </span>
                  </div>

                  <div data-id="element-808">
                    <h3 className="text-3xl font-bold text-brand-dark mb-2" data-id="element-809">
                      {selectedProduct.name}
                    </h3>
                    <p className="text-4xl font-bold text-brand-primary mb-4" data-id="element-810">
                      {selectedProduct.price}
                    </p>

                    <div className="space-y-3 mb-6" data-id="element-811">
                      <div className="flex items-center gap-2 text-slate-600" data-id="element-812">
                        <MapPin className="w-4 h-4" data-id="element-813" />
                        <span data-id="element-814">{selectedProduct.location}</span>
                      </div>
                      <div className="flex items-center gap-2 text-slate-600" data-id="element-815">
                        <Clock className="w-4 h-4" data-id="element-816" />
                        <span data-id="element-817">Posted {selectedProduct.posted}</span>
                      </div>
                    </div>

                    <div className="mb-6" data-id="element-818">
                      <h4 className="font-bold text-brand-dark mb-2" data-id="element-819">
                        Description
                      </h4>
                      <p className="text-slate-600 leading-relaxed" data-id="element-820">
                        {selectedProduct.description}
                      </p>
                    </div>

                    <div className="bg-slate-50 p-4 rounded-xl mb-6" data-id="element-821">
                      <h4 className="font-bold text-brand-dark mb-3" data-id="element-822">
                        Seller Information
                      </h4>
                      <div className="space-y-2" data-id="element-823">
                        <p className="text-slate-700" data-id="element-824">
                          <strong data-id="element-825">Name:</strong> {selectedProduct.seller}
                        </p>
                        <div className="flex items-center gap-2 text-slate-700" data-id="element-826">
                          <Phone className="w-4 h-4" data-id="element-827" />
                          <span data-id="element-828">{selectedProduct.phone}</span>
                        </div>
                        <div className="flex items-center gap-2 text-slate-700" data-id="element-829">
                          <Mail className="w-4 h-4" data-id="element-830" />
                          <span data-id="element-831">{selectedProduct.email}</span>
                        </div>
                      </div>
                    </div>

                    <div className="flex gap-3" data-id="element-832">
                      <Button className="flex-1" data-id="element-833">
                        <MessageCircle className="w-4 h-4 mr-2" data-id="element-834" />
                        Contact Seller
                      </Button>
                      <Button variant="outline" onClick={() => toggleSave(selectedProduct.id)} className={savedItems.includes(selectedProduct.id) ? 'border-red-500 text-red-500' : ''} data-id="element-835">
                        <Heart className={`w-4 h-4 ${savedItems.includes(selectedProduct.id) ? 'fill-current' : ''}`} data-id="element-836" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>

      {/* Search Header */}
      <div className="bg-white border-b border-slate-200 sticky top-20 z-20 shadow-sm" data-id="element-837">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-838">
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between mb-4" data-id="element-839">
            <div className="relative w-full md:max-w-lg" data-id="element-840">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-841" />
              <input type="text" placeholder="Search for appliances, furniture, etc..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-brand-primary focus:outline-none" data-id="element-842" />
            </div>
            <Button className="hidden md:flex" data-id="element-843">
              <ShoppingBag className="w-4 h-4 mr-2" data-id="element-844" />
              Sell Item
            </Button>
          </div>

          {/* Categories */}
          <div className="flex gap-2 overflow-x-auto pb-2 no-scrollbar" data-id="element-845">
            {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeCategory === cat.id ? 'bg-brand-dark text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`} data-id="element-846">
                <cat.icon className="w-4 h-4" data-id="element-847" />
                {cat.label}
              </button>)}
          </div>
        </div>
      </div>

      <Section className="!py-8" data-id="element-848">
        <div className="flex gap-8" data-id="element-849">
          {/* Filters Sidebar - Desktop */}
          <div className="hidden lg:block w-64 flex-shrink-0 space-y-6" data-id="element-850">
            <Card data-id="element-851">
              <CardHeader data-id="element-852">
                <CardTitle className="text-lg" data-id="element-853">Filters</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6" data-id="element-854">
                <div data-id="element-855">
                  <h3 className="font-semibold text-brand-dark mb-3" data-id="element-856">
                    Price Range
                  </h3>
                  <div className="space-y-2" data-id="element-857">
                    <Input placeholder="Min (₦)" value={priceRange.min} onChange={e => setPriceRange({
                    ...priceRange,
                    min: e.target.value
                  })} type="number" data-id="element-858" />
                    <Input placeholder="Max (₦)" value={priceRange.max} onChange={e => setPriceRange({
                    ...priceRange,
                    max: e.target.value
                  })} type="number" data-id="element-859" />
                  </div>
                </div>

                <div data-id="element-860">
                  <h3 className="font-semibold text-brand-dark mb-3" data-id="element-861">
                    Condition
                  </h3>
                  <div className="space-y-2" data-id="element-862">
                    {['New', 'Like New', 'Good', 'Fair'].map(cond => <label key={cond} className="flex items-center gap-2 text-sm text-slate-600 cursor-pointer" data-id="element-863">
                        <input type="checkbox" checked={selectedConditions.includes(cond)} onChange={() => toggleCondition(cond)} className="rounded border-slate-300 text-brand-primary focus:ring-brand-primary" data-id="element-864" />
                        {cond}
                      </label>)}
                  </div>
                </div>

                <Button variant="outline" className="w-full" onClick={() => {
                setPriceRange({
                  min: '',
                  max: ''
                });
                setSelectedConditions([]);
              }} data-id="element-865">
                  Clear Filters
                </Button>
              </CardContent>
            </Card>
          </div>

          {/* Product Grid */}
          <div className="flex-1" data-id="element-866">
            <div className="flex justify-between items-center mb-6" data-id="element-867">
              <h2 className="text-xl font-bold text-brand-dark" data-id="element-868">
                {filteredProducts.length} Items Found
              </h2>
              <div className="flex gap-2" data-id="element-869">
                <select value={sortBy} onChange={e => setSortBy(e.target.value)} className="h-9 rounded-md border border-slate-300 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-brand-primary" data-id="element-870">
                  <option value="recent" data-id="element-871">Most Recent</option>
                  <option value="price-low" data-id="element-872">Price: Low to High</option>
                  <option value="price-high" data-id="element-873">Price: High to Low</option>
                </select>
                <div className="flex border border-slate-300 rounded-md overflow-hidden" data-id="element-874">
                  <button onClick={() => setViewMode('grid')} className={`p-2 ${viewMode === 'grid' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-875">
                    <Grid3x3 className="w-4 h-4" data-id="element-876" />
                  </button>
                  <button onClick={() => setViewMode('list')} className={`p-2 ${viewMode === 'list' ? 'bg-brand-primary text-white' : 'bg-white text-slate-600'}`} data-id="element-877">
                    <List className="w-4 h-4" data-id="element-878" />
                  </button>
                </div>
              </div>
            </div>

            {/* Featured Products */}
            {featuredProducts.length > 0 && <div className="mb-8" data-id="element-879">
                <div className="flex items-center gap-2 mb-4" data-id="element-880">
                  <TrendingUp className="w-5 h-5 text-brand-primary" data-id="element-881" />
                  <h3 className="text-lg font-bold text-brand-dark" data-id="element-882">
                    Featured Items
                  </h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-883">
                  {featuredProducts.map((product, index) => <motion.div key={product.id} initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                delay: index * 0.1
              }} data-id="element-884">
                      <Card className="overflow-hidden hover:shadow-md transition-shadow group h-full flex flex-col border-brand-primary/30" data-id="element-885">
                        <div className="relative h-48 overflow-hidden bg-slate-100 cursor-pointer" onClick={() => setSelectedProduct(product)} data-id="element-886">
                          <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-887" />
                          <span className={`absolute top-3 right-3 px-2 py-1 rounded-full text-xs font-bold shadow-sm ${getConditionColor(product.condition)}`} data-id="element-888">
                            {product.condition}
                          </span>
                          <div className="absolute top-3 left-3 px-2 py-1 bg-brand-primary text-white text-xs font-bold rounded-full" data-id="element-889">
                            FEATURED
                          </div>
                          <button onClick={e => {
                      e.stopPropagation();
                      toggleSave(product.id);
                    }} className="absolute bottom-3 right-3 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-colors" data-id="element-890">
                            <Heart className={`w-4 h-4 ${savedItems.includes(product.id) ? 'fill-red-500 text-red-500' : 'text-slate-600'}`} data-id="element-891" />
                          </button>
                        </div>

                        <div className="p-4 flex-1 flex flex-col" data-id="element-892">
                          <div className="mb-2" data-id="element-893">
                            <h3 className="font-bold text-brand-dark text-lg line-clamp-1 cursor-pointer hover:text-brand-primary" onClick={() => setSelectedProduct(product)} data-id="element-894">
                              {product.name}
                            </h3>
                            <p className="text-lg font-bold text-brand-primary" data-id="element-895">
                              {product.price}
                            </p>
                          </div>

                          <div className="space-y-2 mb-4" data-id="element-896">
                            <div className="flex items-center text-xs text-slate-500" data-id="element-897">
                              <MapPin className="w-3 h-3 mr-1" data-id="element-898" />
                              {product.location}
                            </div>
                            <div className="flex items-center text-xs text-slate-500" data-id="element-899">
                              <Clock className="w-3 h-3 mr-1" data-id="element-900" />
                              Posted {product.posted}
                            </div>
                          </div>

                          <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-901">
                            <div className="text-xs font-medium text-slate-600" data-id="element-902">
                              {product.seller}
                            </div>
                            <Button size="sm" variant="outline" className="text-emerald-600 border-emerald-200 hover:bg-emerald-50 hover:text-emerald-700" onClick={() => setSelectedProduct(product)} data-id="element-903">
                              <MessageCircle className="w-4 h-4 mr-1" data-id="element-904" />
                              Contact
                            </Button>
                          </div>
                        </div>
                      </Card>
                    </motion.div>)}
                </div>
              </div>}

            {/* Regular Products */}
            {regularProducts.length > 0 ? <div className={viewMode === 'grid' ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6' : 'space-y-4'} data-id="element-905">
                {regularProducts.map((product, index) => <motion.div key={product.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-906">
                    <Card className={`overflow-hidden hover:shadow-md transition-shadow group ${viewMode === 'list' ? 'flex flex-row' : 'h-full flex flex-col'}`} data-id="element-907">
                      <div className={`relative overflow-hidden bg-slate-100 cursor-pointer ${viewMode === 'list' ? 'w-48 h-48' : 'h-48'}`} onClick={() => setSelectedProduct(product)} data-id="element-908">
                        <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-909" />
                        <span className={`absolute top-3 right-3 px-2 py-1 rounded-full text-xs font-bold shadow-sm ${getConditionColor(product.condition)}`} data-id="element-910">
                          {product.condition}
                        </span>
                        <button onClick={e => {
                    e.stopPropagation();
                    toggleSave(product.id);
                  }} className="absolute top-3 left-3 w-8 h-8 bg-white/90 hover:bg-white rounded-full flex items-center justify-center transition-colors" data-id="element-911">
                          <Heart className={`w-4 h-4 ${savedItems.includes(product.id) ? 'fill-red-500 text-red-500' : 'text-slate-600'}`} data-id="element-912" />
                        </button>
                      </div>

                      <div className="p-4 flex-1 flex flex-col" data-id="element-913">
                        <div className="mb-2" data-id="element-914">
                          <h3 className="font-bold text-brand-dark text-lg line-clamp-1 cursor-pointer hover:text-brand-primary" onClick={() => setSelectedProduct(product)} data-id="element-915">
                            {product.name}
                          </h3>
                          <p className="text-lg font-bold text-brand-primary" data-id="element-916">
                            {product.price}
                          </p>
                        </div>

                        <div className="space-y-2 mb-4" data-id="element-917">
                          <div className="flex items-center text-xs text-slate-500" data-id="element-918">
                            <MapPin className="w-3 h-3 mr-1" data-id="element-919" />
                            {product.location}
                          </div>
                          <div className="flex items-center text-xs text-slate-500" data-id="element-920">
                            <Clock className="w-3 h-3 mr-1" data-id="element-921" />
                            Posted {product.posted}
                          </div>
                        </div>

                        <div className="mt-auto pt-4 border-t border-slate-100 flex items-center justify-between" data-id="element-922">
                          <div className="text-xs font-medium text-slate-600" data-id="element-923">
                            {product.seller}
                          </div>
                          <Button size="sm" variant="outline" className="text-emerald-600 border-emerald-200 hover:bg-emerald-50 hover:text-emerald-700" onClick={() => setSelectedProduct(product)} data-id="element-924">
                            <MessageCircle className="w-4 h-4 mr-1" data-id="element-925" />
                            Contact
                          </Button>
                        </div>
                      </div>
                    </Card>
                  </motion.div>)}
              </div> : <div className="text-center py-20 bg-white rounded-xl border border-slate-100" data-id="element-926">
                <ShoppingBag className="w-12 h-12 text-slate-300 mx-auto mb-4" data-id="element-927" />
                <h3 className="text-lg font-medium text-brand-dark" data-id="element-928">
                  No items found
                </h3>
                <p className="text-slate-500" data-id="element-929">
                  Try adjusting your search or filters
                </p>
              </div>}
          </div>
        </div>
      </Section>
    </div>;
}